import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedKiloGLMFlowListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

function useGLMFlows(): UseInfiniteQueryResult<AxiosResponse<PaginatedKiloGLMFlowListList>> {
  const fetchGLMFlows = ({
    pageParam = { limit: '20', offset: '0' },
  }: {
    pageParam?: { limit: string; offset: string };
  }): Promise<AxiosResponse<PaginatedKiloGLMFlowListList>> => {
    const params = pageParam;

    return client.get(`kilo-glm-flows/?${encodeUrlParams(params)}`);
  };
  return useInfiniteQuery(['kilo-glm-flows'], fetchGLMFlows, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}
export default useGLMFlows;
